export default __webpack_public_path__ + "3b78b50130a3e7c8cac1580b4427160b.svg";